// src/redux/features/actions/sms.ts
import { axios } from "@/redux/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const GetSMSThunk = createAsyncThunk(
  "sms/list",
  async (data: any = {}, { rejectWithValue }) => {
    try {
    
      const res = await axios.get("/v1/sms", {
        headers: { "Content-Type": "application/json" },
        params: { ...data },
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
     
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const ResendSMSThunk = createAsyncThunk(
  "sms/resend",
  async (smsId: string, { rejectWithValue }) => {
    try {
      const res = await axios.post(`/v1/sms/resend/${smsId}`);
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
); 